import { BackgroundCheckStatus } from '@/backend/features/background-check/types';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import SafetyCheckIcon from '@juvare/common-web-ui/icons/SafetyCheck';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import React, { ReactNode } from 'react';

export const getBackgroundCheckStatusIcon = (status: string) => {
    const removeModeratorIcon = <RemoveModeratorIcon sx={{ color: themeColors.accent.red.base }} />;
    const safetyCheckIcon = <SafetyCheckIcon sx={{ color: themeColors.accent.blue.base }} />;
    const verifiedUserIcon = <VerifiedUserIcon sx={{ color: themeColors.accent.green.base }} />;
    const addModeratorIcon = <AddModeratorIcon sx={{ color: themeColors.accent.grey.base }} />;

    const iconsMap: Record<BackgroundCheckStatus, ReactNode> = {
        completeDenied: removeModeratorIcon,
        didNotConsent: removeModeratorIcon,
        formIncomplete: removeModeratorIcon,
        missingFields: removeModeratorIcon,
        processingError: removeModeratorIcon,
        processingNeedsAttention: removeModeratorIcon,
        unknown: removeModeratorIcon,
        processingPending: safetyCheckIcon,
        processingResearching: safetyCheckIcon,
        processingSubmitted: safetyCheckIcon,
        completeClear: verifiedUserIcon,
        invalidSsn: addModeratorIcon,
        readyToSubmit: addModeratorIcon,
        reviewAndTakeAction: addModeratorIcon,
    };

    return iconsMap[status as BackgroundCheckStatus] ?? <ErrorIcon sx={{ color: themeColors.accent.red.base }} />;
};
